import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800">
      <h1 className="text-4xl font-bold mb-6 text-center">Terms and Conditions</h1>
      <p className="mb-4 text-center text-gray-600">Effective Date: Launch Date</p>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">1. Introduction</h2>
        <p>
          Welcome to <strong>Biss Distro</strong>. These Terms and Conditions govern your use of our music distribution platform. By accessing or using our services, you agree to comply with these terms.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">2. Music Upload and Distribution</h2>
        <ul className="list-disc ml-6">
          <li>Uploaded music will take up to <strong>14 days</strong> to appear on streaming platforms.</li>
          <li>Music metadata (title, description, and other text fields) can be edited within <strong>24 hours</strong> of uploading.</li>
          <li>Music files and cover images <strong>cannot be changed</strong> once uploaded.</li>
          <li>You confirm that you own or have the necessary rights to distribute any uploaded content.</li>
          <li>We reserve the right to remove any content that violates intellectual property laws, contains explicit or prohibited material, or breaches our policies.</li>
        </ul>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">3. Payments and Refunds</h2>
        <ul className="list-disc ml-6">
          <li>All credit card transactions are securely processed through <strong>Monnify</strong>, and we do not store your payment details.</li>
          <li>Refunds for failed payments are processed only after successful verification.</li>
          <li>Once a plan is successfully purchased, refunds will be processed within <strong>5 business days</strong> from the date of purchase.</li>
          <li>Chargebacks or fraudulent transactions may result in account suspension.</li>
        </ul>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">4. Subscription Plans and Cancellations</h2>
        <ul className="list-disc ml-6">
          <li>Plan cancellations are only possible within <strong>24 hours</strong> of purchase.</li>
          <li>Cancellations are only valid if the user has <strong>not uploaded any music</strong> or utilized any plan benefits.</li>
          <li>After the cancellation period, no refunds or downgrades will be processed.</li>
          <li>Plan renewals are automatically processed unless manually canceled by the user.</li>
        </ul>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">5. User Responsibilities</h2>
        <ul className="list-disc ml-6">
          <li>You are responsible for maintaining the security of your account credentials.</li>
          <li>Any unauthorized access or activity on your account should be reported immediately.</li>
          <li>You must not use our platform for any illegal, fraudulent, or malicious activities.</li>
          <li>Violation of these terms may result in account suspension or termination.</li>
        </ul>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">6. Content Ownership and Rights</h2>
        <p>
          By uploading content to our platform, you retain full ownership but grant us a non-exclusive license to distribute and promote your music on your behalf.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">7. Limitation of Liability</h2>
        <p>
          We do not guarantee uninterrupted access to our platform. We are not liable for any losses incurred due to service disruptions, third-party errors, or content removal.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">8. Changes to Terms</h2>
        <p>
          We may update these Terms and Conditions periodically. Continued use of our platform after updates constitutes acceptance of the revised terms.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">9. Contact Information</h2>
        <p>
          If you have any questions regarding these terms, please contact us at:
        </p>
        <p className="font-medium">
          Email: <a href="mailto:support@[yourwebsite].com" className="text-blue-600 hover:underline">support@blissdistro.com</a>
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;
